import ChooseBookmakerPageСontainer, {
    ChooseBookmakerPage,
} from './ChooseBookmakerPage';

export {
    ChooseBookmakerPageСontainer as default,
    ChooseBookmakerPage,
};



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/index.js